import styles from './service-item.module.scss';

type Props = {
    metadata: Record<string, any>;
};

const ServiceMetadata = ({ metadata }: Props) => {
    return (
        <div className={styles.metadataList}>
            {Object.keys(metadata).map((key) => (
                <span key={key} className={styles.metadataProperty}>
                    <span className={styles.key}>{key}:&nbsp;</span>
                    <span className={styles.value}>
                        {metadata[key].toString()}
                    </span>
                </span>
            ))}
        </div>
    );
};

export { ServiceMetadata };
